import React from 'react';

const ProjectStatusesIndex = React.lazy(() => import("./index"))
const NewProjectStatuses = React.lazy(() => import("./new"))
const EditProjectStatuses = React.lazy(() => import("./edit"))

export default[
	{path:'/project/statuses/:id/edit',component: EditProjectStatuses,name:'Edit ProjectStatus'},
	{path:'/project/statuses/new',component: NewProjectStatuses,name:'New ProjectStatus'},  
	{path:'/project/statuses',component: ProjectStatusesIndex,name:'ProjectStatuses'}, 
]

// import ProjectStatusesRoutes from "modules/project/statuses/web/routes"
// routes = _.concat(routes,ProjectStatusesRoutes)
